import { getLocale } from "../runtime";

const da_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tid til en hurtig udstrækning? Dit velbefindende er vigtigt, selv når sider ikke indlæses.`
};

const en_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Time for a quick stretch? Your wellbeing matters even when pages don't load.`
};

const es_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¿Tiempo para un estiramiento rápido? Tu bienestar importa incluso cuando las páginas no cargan.`
};

const fi_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Aika pienelle venyttelylle? Hyvinvointisi on tärkeää, vaikka sivut eivät latautuisikaan.`
};

const nb_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tid for en rask strekk? Din velvære er viktig selv når sider ikke laster.`
};

const sv_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Dags för en snabb stretch? Ditt välmående är viktigt även när sidor inte laddar.`
};

const easteregg3 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_easteregg3(inputs)
	if (locale === "en") return en_easteregg3(inputs)
	if (locale === "es") return es_easteregg3(inputs)
	if (locale === "fi") return fi_easteregg3(inputs)
	if (locale === "nb") return nb_easteregg3(inputs)
	if (locale === "sv") return sv_easteregg3(inputs)
	return "easterEgg3";
};

export { easteregg3 as "easterEgg3" };